import { BookmarksProvider } from "@/providers/bookmarks.provider";
import "../index.css";

import { Posts } from "./posts";
import { useState } from "react";
import { Toaster } from "sonner";

export function App() {
  const [showBookmarks, setShowBookmarks] = useState(false);
  const [tag, setTag] = useState("discuss");

  return (
    <BookmarksProvider>
      <Toaster position="top-right" expand richColors />
      <div className="mx-auto min-h-screen max-w-[1751px] bg-[#0f1319]">
        <div className="flex min-h-[calc(100vh-81px)] flex-col xl:flex-row">
          <main className="flex-1 bg-[#0f1319] px-4 py-5 md:px-6">
            <div className="mx-auto max-w-[1400px]">
              <div className="mb-5 flex items-center gap-3">
                <div className="flex items-center flex-1 gap-3">
                  <h1 className="text-2xl font-bold text-white">
                    Developer Feed
                  </h1>
                  <span className="rounded-full bg-[#242a34] px-3 py-1 text-sm font-semibold text-[#75809a] shadow-[inset_0_0_0_1px_rgba(255,255,255,0.02)]">
                    #{tag}
                  </span>
                </div>
                <button
                  className="rounded-lg border border-gray-700 bg-[#1a1a1a] px-4 py-2 text-sm font-medium text-white hover:bg-[#1f1f1f]"
                  onClick={() => setShowBookmarks((prev) => !prev)}
                >
                  {showBookmarks ? "Show All Posts" : "Show Bookmarked Posts"}
                </button>
              </div>
              <Posts showBookmarks={showBookmarks} tag={tag} />
            </div>
          </main>
        </div>
      </div>
    </BookmarksProvider>
  );
}
